export default __webpack_public_path__ + "static/telepointers-dark-063f0a49a9f65584cd8a4223b609594aaf6a9ea90ea3a16cbf82349106e2dec4.png";